import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

const ProfilesTable = ({
  profiles,
  filterInput,
  setFilterInput,
  selectedRow,
  setSelectedRow,
  hasChanges,
  setHasChanges,
  getTracksByProfile,
  handleInsertTracksByProfile,
  tracksByProfile,
  setProfileOptionSelected,
  uiTypeSelected,
  setUiTypeSelected,
  setProfileName,
  setSelectAll,
  setTracksByProfile,
}) => {
  const [filteredData, setFilteredData] = useState([]);

  //This useEffect filters the Tracks table according to Book Description.
  useEffect(() => {
    let filteredData = profiles;
    //Books input filter
    if (filterInput) {
      filteredData = filteredData.filter((item) =>
        item.ProfileName.toLowerCase().includes(filterInput.toLowerCase()),
      );
    }
    setFilteredData(filteredData);
  }, [profiles, filterInput]);

  // Headers
  let headers,
    profilesTable = [];
  headers = (
    <tr className="text-center" style={{ cursor: "default" }}>
      <th hidden>IDProfile</th>
      <th style={{ width: "290px" }}>Profile Name</th>
    </tr>
  );

  // This function displays the tracks associated with each book
  const showTracksByProfile = (i, idProfile, profileName) => {
    const loadTracks = () => {
      setSelectedRow(i);
      getTracksByProfile(idProfile);
      setProfileOptionSelected(idProfile);
      setProfileName(profileName);
      setSelectAll(false);
    };
    if (hasChanges) {
      Swal.fire({
        title: "Are you sure?",
        text: "Changes will be saved!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancel",
        confirmButtonText: "Yes, save it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          handleInsertTracksByProfile(tracksByProfile, false, true);
          setUiTypeSelected(uiTypeSelected);
          loadTracks();
        } else {
          loadTracks();
          setHasChanges(false);
        }
      });
    } else {
      loadTracks();
    }
  };

  // This constant is used internally to set the selected Track Name or Track Code in the filters
  const handleInputFilterChange = (event) => {
    const loadTracks = () => {
      setHasChanges(false);
      setFilterInput(value);
      setSelectedRow(null);
      setProfileOptionSelected(null);
      setProfileName("");
      setSelectAll(false);
      setTracksByProfile([]);
    };

    setFilterInput(event.target.value);
    const value = event.target.value;
    if (hasChanges) {
      Swal.fire({
        title: "Are you sure?",
        text: "Changes will be saved!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancel",
        confirmButtonText: "Yes, save it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          handleInsertTracksByProfile(tracksByProfile, false);
        } else {
          loadTracks();
        }
      });
    } else {
      loadTracks();
    }
  };

  // The main Profiles table
  if (profiles) {
    profilesTable = filteredData.map((item, i) => {
      return (
        <React.Fragment key={i}>
          <tr
            key={item.ProfileID}
            onClick={() =>
              showTracksByProfile(i, item.ProfileID, item.ProfileName)
            }
            className={selectedRow === i ? "shadedRow" : ""}
            style={{ cursor: "pointer" }}
          >
            <td key={"ProfileID" + i} className="d-none">
              {item.ProfileID}
            </td>
            {/* Profile Name */}
            <td
              key={"Description" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "left",
                width: "290px",
                maxWidth: "290px",
              }}
            >
              <div
                title={item.ProfileName}
                style={{
                  maxWidth: "290px",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {item.ProfileName}
              </div>
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <p
          className="lead"
          style={{ color: "#8c8c8c", fontSize: "16px", cursor: "default" }}
        >
          Profile List
        </p>
      </div>
      <div style={{ textAlign: "center" }}>
        <input
          value={filterInput}
          onChange={handleInputFilterChange}
          placeholder={"Profile Search..."}
          className="form-control mb-1"
        />
      </div>
      <div
        className="tableProfilesTracks"
        style={{
          overflow: "auto",
        }}
      >
        <table className="table table-hover table-sm mt-2">
          <thead
            style={{ position: "sticky", top: "0", background: "#d9d9d9" }}
          >
            {headers}
          </thead>
          <tbody className="table-lg">{profilesTable}</tbody>
        </table>
      </div>
    </div>
  );
};

export default ProfilesTable;
